import React from 'react';
import styles from '../components/enquiries/Enquiries.module.css';

const ContactSupport = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.headerText}>
            <h1 className={styles.headerTitle}>Contact Support</h1>
            <p className={styles.headerSubtitle}>
              Need a hand? Reach out to the team below and we will get back to you as soon as possible.
            </p>
          </div>
        </div>
      </div>

      <div className={styles.summaryCards}>
        <div
          className={styles.summaryCard}
          style={{
            background: 'var(--brand-gradient-1)',
            borderColor: 'var(--Purple-300)'
          }}
        >
          <div className={styles.summaryCardText}>
            <p className={styles.summaryCardLabel} style={{ color: 'var(--Grey-900)' }}>
              Ethan
            </p>
            <p className={styles.summaryCardValue} style={{ color: 'var(--Grey-900)', opacity: 0.85 }}>
              Primary contact
            </p>
            <div style={{
              marginTop: 'var(--spacing-m)',
              display: 'grid',
              gap: 'var(--spacing-s)'
            }}>
              <div style={{
                padding: 'var(--spacing-m)',
                borderRadius: 'var(--radius-lg)',
                background: 'var(--Grey-50)',
                border: '1px solid var(--Stroke-Light)'
              }}>
                <p style={{
                  margin: 0,
                  fontSize: 'var(--font-size-body5)',
                  color: 'var(--Text-Tertiary)',
                  letterSpacing: 'var(--letter-spacing-wide)',
                  textTransform: 'uppercase',
                  fontWeight: 'var(--font-weight-semibold)'
                }}>
                  Email
                </p>
                <p style={{ margin: '4px 0 0 0', fontSize: 'var(--font-size-body3)' }}>
                  <a
                    href="mailto:ethan@boutee.co.uk"
                    style={{ color: 'inherit', textDecoration: 'none' }}
                  >
                    ethan@boutee.co.uk
                  </a>
                </p>
              </div>

              <div style={{
                padding: 'var(--spacing-m)',
                borderRadius: 'var(--radius-lg)',
                background: 'var(--Grey-50)',
                border: '1px solid var(--Stroke-Light)'
              }}>
                <p style={{
                  margin: 0,
                  fontSize: 'var(--font-size-body5)',
                  color: 'var(--Text-Tertiary)',
                  letterSpacing: 'var(--letter-spacing-wide)',
                  textTransform: 'uppercase',
                  fontWeight: 'var(--font-weight-semibold)'
                }}>
                  Phone
                </p>
                <p style={{ margin: '4px 0 0 0', fontSize: 'var(--font-size-body3)' }}>
                  <a
                    href="tel:07585006610"
                    style={{ color: 'inherit', textDecoration: 'none' }}
                  >
                    07585 006 610
                  </a>
                </p>
              </div>

              <div style={{
                padding: 'var(--spacing-m)',
                borderRadius: 'var(--radius-lg)',
                background: 'var(--Grey-50)',
                border: '1px solid var(--Stroke-Light)'
              }}>
                <p style={{
                  margin: 0,
                  fontSize: 'var(--font-size-body5)',
                  color: 'var(--Text-Tertiary)',
                  letterSpacing: 'var(--letter-spacing-wide)',
                  textTransform: 'uppercase',
                  fontWeight: 'var(--font-weight-semibold)'
                }}>
                  WhatsApp
                </p>
                <p style={{ margin: '4px 0 0 0', fontSize: 'var(--font-size-body4)', color: 'var(--Text-Secondary)' }}>
                  Text me on WhatsApp if needed · Call me whenever - day or night!
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.summaryCard}>
          <div className={styles.summaryCardText}>
            <p className={styles.summaryCardLabel}>Billy</p>
            <p className={styles.summaryCardValue}>
              <a
                href="mailto:billy@boutee.co.uk"
                style={{ color: 'inherit', textDecoration: 'none' }}
              >
                billy@boutee.co.uk
              </a>
            </p>
            <p style={{ margin: 0, fontSize: 'var(--font-size-body4)', color: 'var(--Text-Secondary)' }}>
              Alternative email - can be used if Ethan is unavailable or for Billy specifically.
            </p>
          </div>
        </div>

        <div className={styles.summaryCard}>
          <div className={styles.summaryCardText}>
            <p className={styles.summaryCardLabel}>Other</p>
            <p className={styles.summaryCardValue}>
              <a
                href="https://www.boutee.co.uk/"
                target="_blank"
                rel="noreferrer"
                style={{ color: 'inherit', textDecoration: 'none' }}
              >
                www.boutee.co.uk
              </a>
            </p>
            <p style={{ margin: 0, fontSize: 'var(--font-size-body4)', color: 'var(--Text-Secondary)' }}>
              Access the main Boutee site.
            </p>
            <div style={{ marginTop: 'var(--spacing-s)' }}>
              <p className={styles.summaryCardValue} style={{ marginBottom: '4px' }}>
                <a
                  href="mailto:info@boutee.co.uk"
                  style={{ color: 'inherit', textDecoration: 'none' }}
                >
                  info@boutee.co.uk
                </a>
              </p>
              <p style={{ margin: 0, fontSize: 'var(--font-size-body4)', color: 'var(--Text-Secondary)' }}>
                You may give this to customers if they need to reach out to us.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSupport;
